<template>
    <div class="modal-wrapper">
        <CoreStringInput
            v-model="name"
            class="my-6"
            name="item_name"
            placeholder="§ui.placeholder_input_name"
            ref="nameInput"
        />
        <div class="flex justify-start gap-2">
            <CoreButton
                :disabled="!isValid"
                label="§ui_button.save"
                @click="handleSave"
                icon="pi-save"
            />

            <CoreButton
                label="§ui_button.cancel"
                variant="tertiary"
                @click="modalStore.setClose"
                icon="pi-times"
            />
        </div>
    </div>
</template>

<script>
import { useOptionsStore } from '@/stores/options'
import { useModalStore } from '@/stores/modal'
import CoreStringInput from '@/components/core/CoreStringInput.vue'
import CoreButton from '@/components/core/CoreButton.vue'

export default {
    name: 'CreateItemModal',

    components: {
        CoreStringInput,
        CoreButton,
    },

    data() {
        return {
            optionsStore: useOptionsStore(),
            modalStore: useModalStore(),
            name: '',
        }
    },

    computed: {
        isValid() {
            return this.name.length > 1
        },
    },

    mounted() {
        setTimeout(() => {
            if (this.$refs.nameInput && this.$refs.nameInput.$el) {
                this.$refs.nameInput.$el.firstChild.focus()
            } else if (this.$refs.nameInput && this.$refs.nameInput.focus) {
                this.$refs.nameInput.focus()
            }
        }, 300)
    },

    methods: {
        async handleSave() {
            if (!this.isValid) return

            try {
                await this.optionsStore.saveItem({
                    type: this.modalStore.data.type,
                    route: this.modalStore.data.route,
                    name: this.name,
                })

                this.modalStore.setClose()
            } catch (error) {
                console.error('Failed to save item:', error)
            }
        },
    },
}
</script>
